import React, { useState } from "react"
import { Link } from "react-router-dom"
import { Card } from "@capioweb/ui-components"
import { imageBlockDataToImageProps } from "../../utils"

import { ContentHubCategoryPageProps } from "../../pages/ContentHubCategoryPage"
import { onFavButtonClick } from "../MyPagesPersonalizedArticlesBlock/api"
import { AppContext } from "../../context"
import { sendArticleDataLayerPush } from "../../utils/piwikPro"

export type ContentHubArticlePageBlockProps = Pick<
	ContentHubCategoryPageProps,
	| "name"
	| "heading"
	| "preamble"
	| "imageDesktopBlock"
	| "categories"
	| "contentLink"
	| "isSavedArticle"
	| "isLoggedIn"
	| "modelType"
>

const ContentHubArticlePageBlock: React.FC<ContentHubArticlePageBlockProps> = (
	props
) => {
	const [filled, setFilled] = useState(props.isSavedArticle ?? false)
	const srcSetSizes = [
		{ width: 950, breakpoint: 768 },
		{ width: 1200, breakpoint: 2560 },
	]
	const appContext = React.useContext(AppContext)

	return (
		<Link to={props.contentLink?.url ?? "#"} style={{ width: "100%" }}>
			<Card
				h={48.5}
				media={
					props.imageDesktopBlock?.media?.value ? (
						<img
							{...imageBlockDataToImageProps(
								props.imageDesktopBlock,
								false,
								true,
								srcSetSizes
							)}
						/>
					) : null
				}
				tag={
					props.categories?.value?.length > 0 &&
					props.categories?.value[0]?.description
				}
				borderColor="blue33"
			>
				{/* {appContext?.isLoggedIn &&
					props.modelType === "ContentHubArticlePageBlock" && (
						<Card.FavButton
							onClick={(e) => {
								e.preventDefault()
								onFavButtonClick(
									props.contentLink.guidValue,
									props.isSavedArticle,
									setFilled
								)
								sendArticleDataLayerPush("saved", props.heading.value)
							}}
							filled={filled}
						/>
					)} */}
				<Card.Title>{props.heading?.value || props.name}</Card.Title>
				{props.preamble?.value !== "" && (
					<Card.Preamble>{props.preamble.value}</Card.Preamble>
				)}
			</Card>
		</Link>
	)
}

export { ContentHubArticlePageBlock }
